import { BadgeCheck } from 'lucide-react';

export function VerifiedBadge({ verified, size = 'sm', testId = 'verified-badge' }) {
  if (!verified) return null;
  const cls = size === 'lg' ? 'text-sm px-2.5 py-1' : 'text-[10px] px-1.5 py-0.5';
  const icon = size === 'lg' ? 'h-4 w-4' : 'h-3 w-3';
  return (
    <span data-testid={testId} title="Boutique validée par JOTALY"
      className={`inline-flex items-center gap-1 rounded-full bg-emerald-500/15 text-emerald-300 border border-emerald-500/30 font-semibold ${cls}`}>
      <BadgeCheck className={icon} />Vérifiée
    </span>
  );
}
